import {useQuery, UseQueryResult} from "react-query";
import {getAllLocationAuth} from "./locationAuth.services";


export const useGetAllLocationAuth = ():UseQueryResult<LocationAuth[], Error>=>{
    return useQuery(["location_auths"], getAllLocationAuth)
}